// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { getType } from 'typesafe-actions';

import { Chapter, Note, Progress } from '../../types/Model';
import { RootAction, actionCreatorsList } from '../rootActionCreator';

interface OnlineCourseContentState {
  onlineCourseContents: { [key: string]: Chapter[] };
  onlineCourseProgress: { [key: string]: Progress[] };
  onlineCourseNotes: { [key: string]: Note[] };
  isLoading: boolean;
  isNotesLoading: boolean;
  isCreateNoteLoading: boolean;
  isDeleteNoteLoading: boolean;
  isUpdateNoteLoading: boolean;
  isUpdateProgressLoading: boolean;
  error?: Error;
  noteError?: Error;
  progressError?: Error;
}

const {
  getOnlineCourseContentsDataActions,
  getOnlineCourseNotesDataActions,
  createOnlineCourseNoteActions,
  updateOnlineCourseNoteActions,
  updateOnlineCourseProgressActions,
  deleteOnlineCourseNoteActions
} = actionCreatorsList;

export const initialState: OnlineCourseContentState = {
  onlineCourseContents: {},
  onlineCourseNotes: {},
  onlineCourseProgress: {},
  isLoading: true,
  isNotesLoading: true,
  isCreateNoteLoading: false,
  isDeleteNoteLoading: false,
  isUpdateNoteLoading: false,
  isUpdateProgressLoading: false
};

const onlineCourseContentsDataReducer = (state = initialState, action: RootAction):OnlineCourseContentState => {
  switch (action.type) {
    case getType(getOnlineCourseContentsDataActions.request): {
      const { preventLoading = false } = action.payload;
      return {
        ...state,
        isLoading: !preventLoading,
        error: undefined
      };
    }
    case getType(getOnlineCourseContentsDataActions.success): {
      const { payload } = action;
      const {
        id,
        chapters,
        progress,
      } = payload;

      return {
        ...state,
        isLoading: false,
        onlineCourseContents: { [id]: chapters },
        onlineCourseProgress: { [id]: progress },
      };
    }
    case getType(getOnlineCourseContentsDataActions.failure): {
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    }
    case getType(getOnlineCourseNotesDataActions.request): {
      return {
        ...state,
        isNotesLoading: true,
        noteError: undefined
      };
    }
    case getType(getOnlineCourseNotesDataActions.success): {
      const {
        id,
        notes
      } = action.payload;

      return {
        ...state,
        isNotesLoading: false,
        onlineCourseNotes: { [id]: notes },
      };
    }
    case getType(getOnlineCourseNotesDataActions.failure): {
      return {
        ...state,
        isNotesLoading: false,
        noteError: action.payload.error
      };
    }
    case getType(createOnlineCourseNoteActions.request): {
      return {
        ...state,
        isCreateNoteLoading: true,
        noteError: undefined
      };
    }
    case getType(createOnlineCourseNoteActions.success): {
      const {
        id,
        notes
      } = action.payload;

      return {
        ...state,
        isCreateNoteLoading: false,
        onlineCourseNotes: { [id]: notes },
      };
    }
    case getType(createOnlineCourseNoteActions.failure): {
      return {
        ...state,
        isCreateNoteLoading: false,
        noteError: action.payload.error
      };
    }
    case getType(updateOnlineCourseNoteActions.request): {
      return {
        ...state,
        isUpdateNoteLoading: true,
        noteError: undefined
      };
    }
    case getType(updateOnlineCourseNoteActions.success): {
      const {
        id,
        notes
      } = action.payload;

      return {
        ...state,
        isUpdateNoteLoading: false,
        onlineCourseNotes: { [id]: notes },
      };
    }
    case getType(updateOnlineCourseNoteActions.failure): {
      return {
        ...state,
        isUpdateNoteLoading: false,
        noteError: action.payload.error
      };
    }
    case getType(deleteOnlineCourseNoteActions.request): {
      return {
        ...state,
        isDeleteNoteLoading: true,
        noteError: undefined
      };
    }
    case getType(deleteOnlineCourseNoteActions.success): {
      const {
        id,
        notes
      } = action.payload;

      return {
        ...state,
        isDeleteNoteLoading: false,
        onlineCourseNotes: { [id]: notes },
      };
    }
    case getType(deleteOnlineCourseNoteActions.failure): {
      return {
        ...state,
        isDeleteNoteLoading: false,
        noteError: action.payload.error
      };
    }
    case getType(updateOnlineCourseProgressActions.request): {
      return {
        ...state,
        isUpdateProgressLoading: true,
        progressError: undefined
      };
    }
    case getType(updateOnlineCourseProgressActions.success): {
      const {
        id,
        progress
      } = action.payload;

      return {
        ...state,
        isUpdateProgressLoading: false,
        onlineCourseProgress: { [id]: progress },
      };
    }
    case getType(updateOnlineCourseProgressActions.failure): {
      return {
        ...state,
        isUpdateProgressLoading: false,
        progressError: action.payload.error
      };
    }
    default: {
      return state;
    }
  }
}

export {onlineCourseContentsDataReducer as default};
